import React from "react";
import { IconList } from "../IconList";
import { LabeledData } from "@/components/LabeledData";
import { PreviewPersonalInformationBlockProps } from "./types";

export const PreviewPersonalInformationBlock = ({
  iconName,
  title,
  data,
}: PreviewPersonalInformationBlockProps) => {
  const dataIsEmpty = data.every((field) => !field.value);

  if (!data || data.length === 0 || dataIsEmpty) {
    return null;
  }

  const renderInformationFields = () => {
    return data.map(({ label, value }) => {
      if (!value) {
        return null;
      }
      return (
        <LabeledData
          key={`${title}-${label}`}
          label={label}
          value={value}
        />
      );
    });
  };

  return (
    <div className="u-card">
      <IconList
        iconItem
        items={{
          icon: iconName,
          title: title,
        }}
        tag={"h6"}
        semibold
      />
      {renderInformationFields()}
    </div>
  );
};
